module.exports = __webpack_public_path__ + "static/media/Santos6estrellas.f980e3f2.png";